import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/Service/notification.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { Meta ,Title} from '@angular/platform-browser';

@Component({
    selector: 'app-referafriend',
    templateUrl: './referafriend.component.html',
    styleUrls: ['./referafriend.component.css'],
    standalone: false
})
export class ReferafriendComponent {
  emailForm: FormGroup;
  constructor(
    public dialog: NgbModal,
    private router: Router,
    private notify: NotificationService,
    private formBuilder: FormBuilder,
    private meta:Meta,
    private title:Title
  ) {
    this.title.setTitle("Refer A Friend | Family Central");
    this.meta.addTag({ name: 'description', content: 'Discover the power of referrals and unlock exclusive rewards with our refer-a-friend program.' });
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
  }

  goToOnboard() {
    if (this.emailForm.valid) {
      const navigationExtras: NavigationExtras = {
        state: {
          email: this.emailForm.get('email').value,
        },
      };
      this.router.navigateByUrl('/signup-type', navigationExtras);
    } else {
      this.notify.showWarning('Please fill in the email field.');
    }
  }
}
